import React from 'react'
import { useHistory } from 'react-router-dom'
import LogoutIcon from '@material-ui/icons/ExitToApp'
import { config } from 'config'
import { MorrisonsWhiteLogo } from 'assets'
import { AuthContainer } from 'containers'
import { Container, ConfirmAlert } from 'components'
import Menu from 'components/Menu'

const { VERSION } = config!

export type HeaderProps = {
  isLoggedIn?: boolean
  isErrorBoundary?: boolean
}

export const Header: React.FC<HeaderProps> = ({ isLoggedIn = false, isErrorBoundary = false }) => {
  const history = useHistory()
  const { user, logOut } = AuthContainer.useContainer()
  const [open, setOpen] = React.useState(false)

  return (
    <section
      data-testid="header"
      className="flex relative text-center bg-primary h-30 w-full text-white text-2xl justify-left items-center"
    >
      <p className="absolute bottom-0 right-0 mr-1 text-xs">{VERSION}</p>
      <Container>
        {isLoggedIn && !isErrorBoundary ? (
          <header className="flex items-center justify-between">
            <div className="flex items-center justify-between">
              <Menu />
              <div className="flex flex-col items-start">
                <h1 className="text-2xl text-left">Welcome to Supplier Data Hub</h1>
                <div className="flex flex-row items-center">
                  <h2 className="text-base mr-2">{user?.userName}</h2>
                  <div title="Logout" aria-label="Logout" className="cursor-pointer" onClick={() => setOpen(true)}>
                    <LogoutIcon fontSize="medium" />
                  </div>
                </div>
              </div>
            </div>
            <MorrisonsWhiteLogo
              className="cursor-pointer"
              onClick={() => {
                history.push('/home')
              }}
            />
          </header>
        ) : (
          <header className="flex justify-end">
            <MorrisonsWhiteLogo
              className={`${!isErrorBoundary ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={() => {
                !isErrorBoundary && history.replace('/')
              }}
            />
          </header>
        )}
      </Container>
      {open && (
        <ConfirmAlert
          title="Are you sure you want to log out?"
          open={open}
          onConfirm={() => {
            setOpen(false)
            logOut()
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </section>
  )
}
